// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#alertsRemindersExpired .counter[data-v-2ff7d6c5]{font-size:.8rem;position:absolute;top:2px;left:10px;padding:3px}", ""]);
// Exports
module.exports = exports;
